/**
 * EventBridge - A utility to bridge events between UIKit and legacy application
 *
 * This utility allows UIKit components to emit events that can be captured
 * by the legacy application, enabling cross-architecture communication.
 */
export const UIKIT_BRIDGE_EVENT = 'uikit-bridge'

export const EVENT_TYPES = {
  SHOW_LOGIN_MODAL: 'show-login-modal',
} as const

export type EventPayload = Record<string, unknown>

export type EventType = (typeof EVENT_TYPES)[keyof typeof EVENT_TYPES]

/**
 * Emits an event that can be captured by the legacy application
 *
 * @param eventType - The type of event to emit
 * @param payload - Optional payload to send with the event
 */
export const emitEvent = (eventType: EventType, payload?: EventPayload): void => {
  const event = new CustomEvent(UIKIT_BRIDGE_EVENT, {
    detail: {
      type: eventType,
      payload: payload || {},
    },
  })

  window.dispatchEvent(event)
}

/**
 * Specific helper for emitting login modal events
 *
 * @param source - The source component requesting the login modal
 * @param additionalData - Any additional data to pass
 */
export const showLoginModal = (source: string, additionalData?: Record<string, unknown>): void => {
  emitEvent(EVENT_TYPES.SHOW_LOGIN_MODAL, {
    from: source,
    ...additionalData,
  })
}
